// Safety net: when a Turbo Frame request gets a response that doesn't contain
// the expected frame (e.g. session expired and server redirected to sign-in),
// do a full page visit to the redirect destination instead of showing an error.
document.addEventListener("turbo:frame-missing", ((event: CustomEvent) => {
  const response = event.detail.response as Response
  if (response.redirected) {
    event.preventDefault()
    event.detail.visit(response.url)
  }
}) as EventListener)
